import { render, staticRenderFns } from "./industryReportList.vue?vue&type=template&id=3a49fdbb&scoped=true"
import script from "./industryReportList.vue?vue&type=script&lang=js"
export * from "./industryReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a49fdbb",
  null
  
)

export default component.exports